import React from 'react'
import { CaretDown, CaretUp } from '@phosphor-icons/react'
import { useUser } from 'src/lib/contexts/UserContext'
import useNavigation, { JourneyStep } from 'src/lib/hooks/useNavigation'
import { useOrganisationContext } from 'src/lib/contexts/OrganisationContext'
import { createJourneyConfig } from 'src/lib/utils/journeyConfig'

interface HeaderProps {
  title: string
  icon: JSX.Element
  currentStep: JourneyStep
}

export const Header: React.FC<HeaderProps> = ({ title, icon, currentStep }) => {
  const { canAccess, isUserConfigured, user } = useUser()
  const {
    getters: { journeyStep, isTablet },
    actions: { setJourneyStepAndNavigate }
  } = useNavigation()
  const {
    getters: { billingPopUp }
  } = useOrganisationContext()

  const hasOverdueInvoices = billingPopUp.hasOverdueInvoices && !user?.isSuperAdmin

  const journeyConfig = createJourneyConfig(journeyStep, canAccess, isUserConfigured, hasOverdueInvoices)

  const enabledSteps = journeyConfig.filter(step => step.isEnabled)

  const handleNextStep = () => {
    const currentIndex = enabledSteps.findIndex(step => step.id === currentStep)
    const nextIndex = (currentIndex + 1) % enabledSteps.length
    const nextStep = enabledSteps[nextIndex]
    setJourneyStepAndNavigate(nextStep.id, user)
  }

  const handlePreviousStep = () => {
    const currentIndex = enabledSteps.findIndex(step => step.id === currentStep)
    const previousIndex = currentIndex === 0 ? enabledSteps.length - 1 : currentIndex - 1
    const previousStep = enabledSteps[previousIndex]
    setJourneyStepAndNavigate(previousStep.id, user)
  }

  return (
    <div className='flex items-center justify-between py-[10px] px-3 gap-2'>
      <div className='flex items-center gap-2'>
        <div>{icon}</div>
        <span className='text-text-sm-medium'>{title}</span>
      </div>

      {!isTablet && (
        <div className='flex gap-1 ml-auto'>
          <CaretDown size={16} className='text-gray-400 p-0.5 cursor-pointer' onClick={() => handleNextStep()} />
          <CaretUp size={16} className='text-gray-400 p-0.5 cursor-pointer' onClick={() => handlePreviousStep()} />
        </div>
      )}
    </div>
  )
}
